import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rangeFields", "weekdayFields"]

  connect() {
    this.update()
  }

  update() {
    const selected = this.element.querySelector('input[name="blackout_date[kind]"]:checked')
    if (!selected) return

    if (selected.value === "weekday") {
      this.rangeFieldsTarget.classList.add("hidden")
      this.weekdayFieldsTarget.classList.remove("hidden")
    } else {
      this.rangeFieldsTarget.classList.remove("hidden")
      this.weekdayFieldsTarget.classList.add("hidden")
    }
  }
}
